import React, {useCallback, useEffect, useMemo, useState} from 'react'

import { useDispatch, useSelector } from 'react-redux'

import {TextField, Button, Typography, Paper, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Checkbox} from '@mui/material'

import useStyles from './styles.js'
import { createCompetition, updateCompetition } from '../../../actions/competitions.js'
import { useTheme } from '@mui/styles'
import { season_all, discipline_all } from '../../../bdd/bddSTUB.js'
import { getUserProvider, isAdminDSAS } from '../../../actions/auth.js'
import SelectGroupProvider from '../../../dsasComponents/SelectGroupProvider.js'
import { useFetch } from '../../../filters/useFetch.js'
import { fetchTeams } from '../../../api/index.js'
import { FETCH_ALL_TEAM } from '../../../constants/actionTypes.js'

function getStyles(name, personName, theme) {
    return {
        fontWeight:
        personName.indexOf(name) === -1
            ? theme.typography.fontWeightRegular
            : theme.typography.fontWeightMedium,
    };
}

let initialState = {
    discipline : '', name : '', enableAPI : false, particularGoalAverage : false, nbDays : '', nbTeamFinalPhase : '', teams : [], season : '', provider : getUserProvider()
}

const FormCompetition = ({ currentId, setCurrentId }) => {
    const classes = useStyles();
    const theme = useTheme();

    const [competitionData, setCompetitionData] = useState(initialState)

    const currentCompetition = useSelector((state) => currentId ? state.competitions.find(p => p._id === currentId) : null)

    const dispatch = useDispatch()

    const teams_all_filter = useMemo(() => {
        return {__force__ : true}
    }, [])

    const [teams_all] = useFetch(fetchTeams, teams_all_filter, undefined, FETCH_ALL_TEAM)

    useEffect(() => {
        if(currentCompetition)
            setCompetitionData(currentCompetition)

    }, [currentCompetition])

    const handleChangeEnableAPI = (event) => {
        setCompetitionData(s => ({...s, enableAPI: event.target.checked}));
      };

    const handleChangeParticularGoalAverage = (event) => {
        setCompetitionData(s => ({...s, particularGoalAverage: event.target.checked}));
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        if(!competitionData.discipline)
            return

        if(currentId){
            dispatch(updateCompetition(currentId, competitionData))
        }else{
            dispatch(createCompetition(competitionData))
        }

        clear()
    }

    const handleChange = (e) => {
        setCompetitionData(s => ({...s, [e.target.name]: e.target.value}))
    }
    

    const clear = () => {
        setCurrentId(null)
        setCompetitionData(initialState)

    }

    return (
        <Paper className={classes.paper}>
            <form autoComplete="off" noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit}>
                <Typography variant="h6"> {currentId ? "Editer " : "Créer "} une compétition </Typography>

                {/*Discipline*/} 
                <FormControl sx={{ m: 1, width: 300 }}  error={!competitionData.discipline} >
                    <InputLabel id={"disciplinecompet"}>Discipline</InputLabel>
                    <Select 
                        labelId={'disciplinecompet'}
                        id={"disciplinecompetselect"}
                        name={'discipline'}
                        value={competitionData.discipline}
                        label={'Discipline'}
                        onChange={handleChange}
                    >
                        {discipline_all && discipline_all.map(i => (<MenuItem key={i._id} value={i._id}>{i.name ? i.name : `${i.lastname} ${i.firstname}`}</MenuItem>))}
                    </Select>
                </FormControl>

                <TextField
                    name="name" 
                    variant="outlined"
                    label="Nom" 
                    fullWidth 
                    value={competitionData.name}
                    onChange={handleChange}
                />

                {/*Saison*/} 
                <FormControl sx={{ m: 1, width: 300 }}>
                    <InputLabel id={"seasoncompet"}>Saison</InputLabel>
                    <Select 
                        labelId={'seasoncompet'}
                        id={"seasoncompetselect"}
                        name={'season'}
                        value={competitionData.season}
                        label={'Saison'}
                        onChange={handleChange}
                    >
                        {season_all && season_all.map(i => (<MenuItem key={i._id} value={i._id}>{i.name ? i.name : `${i.lastname} ${i.firstname}`}</MenuItem>))}
                    </Select>
                </FormControl>

                <FormControlLabel
                    control={
                        <Checkbox
                        checked={competitionData.enableAPI}
                        onChange={handleChangeEnableAPI}
                        name="enableAPI"
                        />
                    }
                    label="API"
                    />

                <FormControlLabel
                    control={
                        <Checkbox
                        checked={competitionData.particularGoalAverage}
                        onChange={handleChangeParticularGoalAverage}
                        name="particularGoalAverage"
                        />
                    }
                    label="Goalaverage particulier"
                    />

                

                <TextField 
                    name="nbDays" 
                    variant="outlined"
                    label="Nombre de journées" 
                    fullWidth 
                    value={competitionData.nbDays}
                    onChange={handleChange}
                />

                <TextField 
                    name="nbTeamFinalPhase" 
                    variant="outlined"
                    label="Nombre d'équipes en phase finale" 
                    fullWidth 
                    value={competitionData.nbTeamFinalPhase}
                    onChange={handleChange}
                />

<TextField 
                    name="thirdPartyEntityId" 
                    variant="outlined"
                    label="Id externe" 
                    fullWidth
                    value={competitionData.thirdPartyEntityId || ''}
                    onChange={handleChange}
                />

                <TextField 
                    name="thirdPartyId" 
                    variant="outlined"
                    label="Origine id externe" 
                    fullWidth
                    value={competitionData.thirdPartyId || ''}
                    onChange={handleChange}
                />



                {isAdminDSAS() && <SelectGroupProvider value={competitionData.provider} onChange={(e) => setCompetitionData(s => ({...s, provider : e.target.value}))}/>}

                <Button className={classes.buttonSubmit} variant="contained" color="primary" size="large" type="submit" fullWidth> Valider </Button>
                <Button variant="contained" color="secondary" size="small" onClick={clear} fullWidth> Clear </Button>


            </form>

        </Paper>
    )
}

export default FormCompetition